<template>
  <div>
    <data-table
      ref="table"
      :key="currentLocale"
      :items="repolistFunc"
      :per-page="20"
      :sort-desc="true"
      :theme="$_ui_theme_tables"
    >
      <data-column
        :sortable="false"
        field="serial"
        :label="$l('components.configurationUpdate.serial', 'No')"
        width="7%"
      />

      <data-column
        field="fileName"
        :label="$l('components.configurationUpdate.fileName', 'File name')"
        width="20%"
      >
        <template #default="{ item }">
          <div class="truncate">
            {{ item.fileName }}
          </div>
        </template>
      </data-column>
      <data-column
        field="createdAt"
        :label="$l('components.configurationUpdate.createdAt', 'Created At')"
      >
        <template #default="{ item }">
          <div>
            {{ renderTime(item.createdAt) }}
          </div>
        </template>
      </data-column>

      <data-column
        field="os"
        :label="$l('components.configurationUpdate.os', 'OS')"
        :sortable="false"
      >
        <template #default="{ item }">
          <div>
            {{ renderOSName(item.os) }}
          </div>
        </template>
        <template #header>
          <div class="column-header">
            <span>{{ $l("components.configurationUpdate.os", "OS") }}</span>

            <Dropdown
              placement="bottom-start"
              trigger="custom"
              :visible="filter.filterOS.isFilterOpen"
              @on-clickoutside="handleCloseFilter(filter.filterOS.filterType)"
            >
              <span
                href="javascript:void(0)"
                @click="toggleFilter('filterOS')"
                class="icon"
              >
                <svg-icon
                  type="mdi"
                  :path="path"
                  :class="{
                    'filter-active': filter.filterOS.isSubmitFilter,
                  }"
                ></svg-icon>
              </span>
              <DropdownMenu slot="list">
                <div class="menu-list">
                  <label v-for="(i, index) in listOS" :key="index">
                    <DropdownItem>
                      <input
                        type="checkbox"
                        v-model="filter.filterOS.filterValues"
                        :value="i.id"
                      />

                      <span style="margin-left: 10px">{{ i.name }}</span>
                    </DropdownItem>
                    <div class="divider"></div>
                  </label>
                </div>
                <div class="filter-button">
                  <Button
                    type="text"
                    size="small"
                    :disabled="!filter.filterOS.filterValues.length"
                    @click="submitFilter(filter.filterOS.filterType)"
                    ><span style="font-weight: bold">{{
                      $l("global.submit", "Submit")
                    }}</span></Button
                  >
                  <Button
                    type="text"
                    size="small"
                    color="#2096f2"
                    @click="resetFilter(filter.filterOS.filterType)"
                    ><span style="font-weight: bold">{{
                      $l("global.reset", "Reset")
                    }}</span></Button
                  >
                </div>
              </DropdownMenu>
            </Dropdown>
          </div>
        </template>
      </data-column>
      <data-column
        field="version"
        :label="$l('components.configurationUpdate.version', 'Version')"
        :sortable="false"
      >
        <template #header>
          <div class="column-header">
            <span>{{
              $l("components.configurationUpdate.version", "Version")
            }}</span>

            <div class="version-filter">
              <Dropdown
                placement="bottom-start"
                trigger="custom"
                :visible="filter.filterVersion.isFilterOpen"
                @on-clickoutside="
                  handleCloseFilter(filter.filterVersion.filterType)
                "
              >
                <span
                  href="javascript:void(0)"
                  @click="toggleFilter('filterVersion')"
                  class="icon"
                >
                  <svg-icon
                    type="mdi"
                    :path="path"
                    :class="{
                      'filter-active': filter.filterVersion.isSubmitFilter,
                    }"
                  ></svg-icon>
                </span>
                <DropdownMenu slot="list">
                  <div class="menu-list version">
                    <v-select
                      v-model="filter.filterVersion.filterValues"
                      :options="listVersions"
                      class="hello"
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          v-bind="attributes"
                          v-on="events"
                          v-model="search"
                          :placeholder="
                            $l(
                              'components.configurationUpdate.version',
                              'Version'
                            )
                          "
                        />
                      </template>
                    </v-select>
                  </div>

                  <div
                    class="divider"
                    style="margin-top: 10px; margin-bottom: 10px"
                  ></div>
                  <div class="filter-button">
                    <Button
                      type="text"
                      size="small"
                      :disabled="!filter.filterVersion.filterValues.length"
                      @click="submitFilter(filter.filterVersion.filterType)"
                      ><span style="font-weight: bold">{{
                        $l("global.submit", "Submit")
                      }}</span></Button
                    >
                    <Button
                      type="text"
                      size="small"
                      color="#2096f2"
                      @click="resetFilter(filter.filterVersion.filterType)"
                      ><span style="font-weight: bold">{{
                        $l("global.reset", "Reset")
                      }}</span></Button
                    >
                  </div>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </template>
      </data-column>

      <data-column
        field="type"
        :label="$l('components.configurationUpdate.type', 'Type')"
        :sortable="true"
        width="12%"
      >
        <template #default="{ item }">
          <div>
            <span>{{ renderTypeName(item.type) }}</span>
            <span
              v-if="item.os === '_'"
              style="
                font-size: 9px;
                color: #31cb09;
                position: relative;
                bottom: 5px;
                left: 2px;
              "
              >Offline
            </span>
          </div>
        </template>

        <template #header>
          <div class="column-header">
            <span>{{ $l("components.configurationUpdate.type", "Type") }}</span>
            <Dropdown
              placement="bottom-start"
              trigger="custom"
              :visible="filter.filterTypes.isFilterOpen"
              @on-clickoutside="
                handleCloseFilter(filter.filterTypes.filterType)
              "
            >
              <span
                href="javascript:void(0)"
                @click="toggleFilter('filterTypes')"
                class="icon"
              >
                <svg-icon
                  type="mdi"
                  :path="path"
                  :class="{
                    'filter-active': filter.filterTypes.isSubmitFilter,
                  }"
                ></svg-icon>
              </span>
              <DropdownMenu slot="list">
                <div class="menu-list">
                  <label v-for="(i, index) in listTypes" :key="index">
                    <DropdownItem>
                      <input
                        type="checkbox"
                        v-model="filter.filterTypes.filterValues"
                        :value="i.value"
                      />

                      <span style="margin-left: 10px">{{ i.name }}</span>
                    </DropdownItem>
                    <div class="divider"></div>
                  </label>
                </div>
                <div class="filter-button">
                  <Button
                    type="text"
                    size="small"
                    :disabled="!filter.filterTypes.filterValues.length"
                    @click="submitFilter(filter.filterTypes.filterType)"
                    ><span style="font-weight: bold">{{
                      $l("global.submit", "Submit")
                    }}</span></Button
                  >
                  <Button
                    type="text"
                    size="small"
                    color="#2096f2"
                    @click="resetFilter(filter.filterTypes.filterType)"
                    ><span style="font-weight: bold">{{
                      $l("global.reset", "Reset")
                    }}</span></Button
                  >
                </div>
              </DropdownMenu>
            </Dropdown>
          </div>
        </template>
      </data-column>

      <data-column field="status" :sortable="false">
        <template #default="{ item }">
          <div
            class="status-column"
            :class="{
              'status-active': item.status === 1,
              'status-inactive': item.status === 2,
              'status-init': item.status === 0,
            }"
          >
            {{
              item.status === 1
                ? $l("components.configurationUpdate.ready", "Ready")
                : item.status === 2
                ? $l("components.configurationUpdate.error", "Error")
                : $l("components.configurationUpdate.uploading", "Uploading")
            }}
          </div>
        </template>

        <template #header>
          <div class="column-header">
            <span>{{
              $l("components.configurationUpdate.status", "Status")
            }}</span>
            <Dropdown
              placement="bottom-start"
              trigger="custom"
              :visible="filter.filterStatus.isFilterOpen"
              @on-clickoutside="
                handleCloseFilter(filter.filterStatus.filterType)
              "
            >
              <span
                href="javascript:void(0)"
                @click="toggleFilter('filterStatus')"
                class="icon"
              >
                <svg-icon
                  type="mdi"
                  :path="path"
                  :class="{
                    'filter-active': filter.filterStatus.isSubmitFilter,
                  }"
                ></svg-icon>
              </span>
              <DropdownMenu slot="list">
                <div class="menu-list">
                  <label v-for="(i, index) in listStatus" :key="index">
                    <DropdownItem>
                      <input
                        type="checkbox"
                        v-model="filter.filterStatus.filterValues"
                        :value="i.value"
                      />

                      <span style="margin-left: 10px">{{
                        $l(`components.configurationUpdate.${i.name}`)
                      }}</span>
                    </DropdownItem>
                    <div class="divider"></div>
                  </label>

                  <div class="filter-button">
                    <Button
                      type="text"
                      size="small"
                      :disabled="!filter.filterStatus.filterValues.length"
                      @click="submitFilter(filter.filterStatus.filterType)"
                      ><span style="font-weight: bold">{{
                        $l("global.submit", "Submit")
                      }}</span></Button
                    >
                    <Button
                      type="text"
                      size="small"
                      color="#2096f2"
                      @click="resetFilter(filter.filterStatus.filterType)"
                      ><span style="font-weight: bold">{{
                        $l("global.reset", "Reset")
                      }}</span></Button
                    >
                  </div>
                </div>
              </DropdownMenu>
            </Dropdown>
          </div>
        </template>
      </data-column>

      <data-column
        field="size"
        :label="$l('components.configurationUpdate.size', 'Size')"
      >
        <template #default="{ item }">
          {{ formatSize(item.size) }}
        </template></data-column
      >

      <data-column :sortable="false" width="7%">
        <template v-if="isAdmin" slot-scope="{ item }">
          <div class="actions-column-repo">
            <Dropdown trigger="click" placement="bottom-start">
              <span href="javascript:void(0)" style="cursor: pointer">
                <octicon :icon="kebabHorizontal" label="kebabHorizontal" />
              </span>
              <DropdownMenu slot="list">
                <DropdownItem
                  v-if="item.status === 1"
                  @click.native="showForm(formModal.formInfor.type, item)"
                >
                  <span>{{
                    $l("components.configurationUpdate.viewInfor", "View Infor")
                  }}</span></DropdownItem
                >
                <div v-if="item.status === 1" class="divider"></div>

                <DropdownItem
                  v-if="isRoot"
                  @click.native="
                    showForm(formModal.formConfirmDeleteRepo.type, item)
                  "
                >
                  <span style="color: red">{{
                    $l(
                      "components.configurationUpdate.deleteFile",
                      "Delete File"
                    )
                  }}</span>
                </DropdownItem>

                <div v-if="item.status === 1 && isRoot" class="divider"></div>

                <DropdownItem
                  @click.native="showForm(formModal.formMD5.type, item)"
                  v-if="item.status === 1"
                >
                  <span>{{
                    $l("components.configurationUpdate.checkMD5", "Check MD5")
                  }}</span>
                </DropdownItem>

                <div v-if="item.status === 1" class="divider"></div>

                <DropdownItem
                  @click.native="downloadFile(item)"
                  v-if="item.status === 1"
                  :class="{ disabled: !item.filePath }"
                >
                  <span>{{
                    $l(
                      "components.configurationUpdate.downloadFile",
                      "Download file"
                    )
                  }}</span>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </template>
      </data-column>
    </data-table>
    <modal :show.sync="formModal.formInfor.isFormOpen" content-width="60%">
      <box>
        <div class="close-icon" @click="formModal.formInfor.isFormOpen = false">
          <Icon size="25" type="ios-close" />
        </div>
        <div style="text-align: center; margin-bottom: 20px">
          <label class="label">{{
            $l(
              "components.configurationUpdate.inforFileUpdate",
              "Infor File Update"
            )
          }}</label>
        </div>

        <div class="columns" style="margin-top: 10px">
          <div class="column is-one-fifth nowrap">
            <div style="width: 80px">
              <strong>{{
                $l("components.configurationUpdate.fileName", "File Name") + ":"
              }}</strong>
            </div>

            <br />

            <div>
              <div style="width: 80px; display: inline-block">
                <strong>{{
                  $l("components.configurationUpdate.createdAt", "Created At") +
                  ":"
                }}</strong>
              </div>
              <div
                style="width: 80px; display: inline-block; margin-left: 400px"
              >
                <strong>{{
                  $l("components.configurationUpdate.creator", "Creator") + ":"
                }}</strong>
              </div>
            </div>

            <br />

            <div>
              <div style="width: 80px; display: inline-block">
                <strong>{{
                  $l("components.configurationUpdate.os", "OS") + ":"
                }}</strong>
              </div>
              <div
                style="width: 80px; display: inline-block; margin-left: 400px"
              >
                <strong>{{
                  $l("components.configurationUpdate.version", "Version") +
                  "/" +
                  $l("components.configurationUpdate.type", "Type") +
                  ":"
                }}</strong>
              </div>
            </div>

            <br />

            <div>
              <div style="width: 80px; display: inline-block">
                <strong>{{
                  $l("components.configurationUpdate.status", "Status") + ":"
                }}</strong>
              </div>
              <div
                style="width: 80px; display: inline-block; margin-left: 400px"
              >
                <strong>{{
                  $l("components.configurationUpdate.size", "Size") + ":"
                }}</strong>
              </div>
            </div>

            <br />

            <div style="width: 80px">
              <strong>{{
                $l("components.configurationUpdate.md5", "MD5") + ":"
              }}</strong>
            </div>
          </div>

          <div class="column nowrap">
            <div>
              <div style="width: 80px; display: inline-block">
                <span>{{ formModal.formInfor.repoInfor.fileName }}</span>
              </div>
            </div>

            <br />

            <div>
              <div style="width: 80px; display: inline-block">
                <span>{{
                  renderTime(formModal.formInfor.repoInfor.createdAt)
                }}</span>
              </div>

              <div
                style="width: 80px; display: inline-block; margin-left: 400px"
              >
                <span>{{ formModal.formInfor.repoInfor.user }}</span>
              </div>
            </div>

            <br />

            <div>
              <div style="width: 80px; display: inline-block">
                <span>{{
                  renderOSName(formModal.formInfor.repoInfor.os)
                }}</span>
              </div>

              <div
                style="width: 80px; display: inline-block; margin-left: 400px"
              >
                <span>{{
                  formModal.formInfor.repoInfor.version +
                  "/" +
                  formModal.formInfor.repoInfor.type
                }}</span>
              </div>
            </div>
            <br />

            <div>
              <div style="width: 80px; display: inline-block">
                <span
                  class="status-column"
                  :class="{
                    'status-active': formModal.formInfor.repoInfor.status === 1,
                    'status-init': formModal.formInfor.repoInfor.status === 0,
                  }"
                  >{{
                    formModal.formInfor.repoInfor.status === 1
                      ? $l("components.configurationUpdate.ready", "Ready")
                      : $l(
                          "components.configurationUpdate.initializing",
                          "Initializing"
                        )
                  }}</span
                >
              </div>

              <div
                style="width: 80px; display: inline-block; margin-left: 400px"
              >
                <span>{{
                  formatSize(formModal.formInfor.repoInfor.size)
                }}</span>
              </div>
            </div>

            <br />

            <div>
              <div style="width: 80px; display: inline-block">
                <span
                  >{{ formModal.formInfor.repoInfor.md5 }}
                  <Icon
                    @click="copyText(formModal.formInfor.repoInfor.md5)"
                    size="25"
                    type="ios-copy"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>

        <div slot="footer" class="field is-grouped is-grouped-right">
          <div class="control">
            <button
              class="button is-info"
              @click.prevent="formModal.formInfor.isFormOpen = false"
            >
              {{ $l("global.close", "Close") }}
            </button>
          </div>
        </div>
      </box>
    </modal>

    <modal :show.sync="formModal.formMD5.isFormOpen">
      <box>
        <div class="close-icon" @click="formModal.formMD5.isFormOpen = false">
          <Icon size="25" type="ios-close" />
        </div>
        <div style="text-align: center; margin-bottom: 20px">
          <label class="label">{{
            $l("components.configurationUpdate.checkMD5", "Check MD5")
          }}</label>
        </div>

        <div class="columns" style="margin-top: 10px">
          <div class="column is-one-fifth nowrap">
            <strong>{{
              $l("components.configurationUpdate.fileName", "File Name") + ":"
            }}</strong>
            <br />
            <br />
            <strong>{{
              $l("components.configurationUpdate.md5", "MD5") + ":"
            }}</strong>
          </div>

          <div class="column nowrap">
            <span>{{ formModal.formMD5.repoInfor.fileName }}</span>
            <br />
            <br />
            <span>
              {{ formModal.formMD5.repoInfor.md5 }}

              <Icon
                @click="copyText(formModal.formMD5.repoInfor.md5)"
                size="25"
                type="ios-copy"
              />
            </span>
          </div>
        </div>
        <div slot="footer" class="field is-grouped is-grouped-right">
          <div class="control">
            <button
              class="button is-info"
              @click.prevent="formModal.formMD5.isFormOpen = false"
            >
              {{ $l("global.close", "Close") }}
            </button>
          </div>
        </div>
      </box>
    </modal>
    <modal :show.sync="formModal.formConfirmDeleteRepo.isFormOpen">
      <box>
        <div
          class="close-icon"
          @click="formModal.formConfirmDeleteRepo.isFormOpen = false"
        >
          <Icon size="25" type="ios-close" />
        </div>

        <div style="text-align: center; margin-bottom: 20px">
          <label class="label">{{
            $l(
              "components.configurationUpdate.confirmDeleteFile",
              "Confirm Delete File"
            )
          }}</label>
        </div>

        <div class="columns" style="margin-top: 10px">
          <div class="column is-one-fifth nowrap">
            <strong>{{
              $l("components.configurationUpdate.fileName", "File Name") + ":"
            }}</strong>
            <br />
            <br />
            <strong>{{
              $l(
                "components.configurationUpdate.warning",
                "Attention! This action cannot be undone"
              ) + "."
            }}</strong>
          </div>

          <div class="column nowrap">
            <span>{{
              formModal.formConfirmDeleteRepo.repoInfor.fileName
            }}</span>
          </div>
        </div>
        <div slot="footer" class="field is-grouped is-grouped-right">
          <div class="control">
            <button
              class="button"
              @click.prevent="
                formModal.formConfirmDeleteRepo.isFormOpen = false
              "
            >
              {{ $l("global.close", "Close") }}
            </button>
          </div>
          <div class="control">
            <button
              class="button is-danger"
              @click.prevent="
                deleteRepo(formModal.formConfirmDeleteRepo.repoInfor)
              "
            >
              {{ $l("global.submit", "Submit") }}
            </button>
          </div>
        </div>
      </box></modal
    >
  </div>
</template>

<script>
import UpdateApi from "@/api/Update";
import { plus, kebabHorizontal, cloudUpload } from "octicons-vue";
import { Tabs, Tab, DataTable, DataColumn, Modal } from "@cyradar/ui";
import SvgIcon from "@jamescoyle/vue-icon";
import vSelect from "vue-select";
import Switches from "vue-switches";
import { mdiFilter, mdiContentCopy } from "@mdi/js";
import Format from "date-fns/format";
import { mapGetters } from "vuex";
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Checkbox,
  Icon,
  Button,
} from "iview";

export default {
  components: {
    Tabs,
    Tab,
    DataTable,
    DataColumn,
    Modal,
    SvgIcon,
    vSelect,
    Switches,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Checkbox,
    Icon,
    Button,
  },

  computed: {
    ...mapGetters(["authenticationClaims", "isAdmin", "currentLocale"]),
  },

  data() {
    return {
      search: "",
      path: mdiFilter,
      pathIconCopy: mdiContentCopy,
      cloudUpload,
      plus,
      kebabHorizontal,
      form: {},
      formModal: {
        formCreate: {
          type: "create",
          repoInfor: {},
          isFormOpen: false,
        },
        formInfor: {
          type: "form-infor",
          repoInfor: {},
          isFormOpen: false,
        },
        formMD5: {
          type: "check-md5",
          repoInfor: {},
          isFormOpen: false,
        },
        formConfirmDeleteRepo: {
          type: "confirm",
          repoInfor: {},
          isFormOpen: false,
        },
      },
      listVersions: [],
      listOS: [],
      listTypes: [
        {
          value: "basic_engine",
          name: "Basic Engine",
        },
        {
          value: "installer_online",
          name: "Online Installer",
        },
        {
          value: "installer_offline",
          name: "Offline Installer",
        },
        {
          value: "db_hash",
          name: "Hash Database",
        },
        {
          value: "db_signature",
          name: "Signature Database",
        },
        {
          value: "db_resource",
          name: "Resource Database",
        },
        {
          value: "advance_engine",
          name: "Advance Engine",
        },
      ],

      listStatus: [
        {
          value: 0,
          name: "uploading",
        },
        {
          value: 1,
          name: "ready",
        },
        {
          value: 2,
          name: "error",
        },
      ],

      filter: {
        filterOS: {
          filterType: "os",
          isFilterOpen: false,
          isSubmitFilter: false,
          filterValues: [],
        },
        filterVersion: {
          filterType: "version",
          isFilterOpen: false,
          isSubmitFilter: false,
          filterValues: "",
        },
        filterTypes: {
          filterType: "types",
          isFilterOpen: false,
          isSubmitFilter: false,
          filterValues: [],
        },
        filterStatus: {
          filterType: "status",
          isFilterOpen: false,
          isSubmitFilter: false,
          filterValues: [],
        },
      },

      isRoot: null,
    };
  },

  watch: {
    "filter.filterTypes.filterValues"(newValue) {
      this.getVersionFilter(this.search);
    },

    search(newValue) {
      this.getVersionFilter(newValue);
    },
  },

  methods: {
    // Filter

    toggleFilter(type) {
      event.stopPropagation();
      Object.keys(this.filter).forEach((key) => {
        if (key !== type) {
          this.filter[key].isFilterOpen = false;
        }
      });

      this.filter[type].isFilterOpen = !this.filter[type].isFilterOpen;
    },

    handleCloseFilter(filterType) {
      if (filterType === this.filter.filterStatus.filterType) {
        if (!this.filter.filterStatus.isSubmitFilter) {
          this.filter.filterStatus.filterValues = [];
        }

        this.filter.filterStatus.isFilterOpen = false;
      }

      if (filterType === this.filter.filterTypes.filterType) {
        if (!this.filter.filterTypes.isSubmitFilter) {
          this.filter.filterTypes.filterValues = [];
        }

        this.filter.filterTypes.isFilterOpen = false;
      }

      if (filterType === this.filter.filterVersion.filterType) {
        if (!this.filter.filterVersion.isSubmitFilter) {
          this.filter.filterVersion.filterValues = [];
        }

        this.filter.filterVersion.isFilterOpen = false;
      }

      if (filterType === this.filter.filterOS.filterType) {
        if (!this.filter.filterOS.isSubmitFilter) {
          this.filter.filterOS.filterValues = [];
        }

        this.filter.filterOS.isFilterOpen = false;
      }
    },

    submitFilter(filterType) {
      if (filterType === this.filter.filterOS.filterType) {
        this.filter.filterOS.isFilterOpen = false;

        if (this.filter.filterOS.filterValues.length === 0) {
          this.filter.filterOS.isSubmitFilter = false;
        } else {
          this.filter.filterOS.isSubmitFilter = true;
          this.$refs.table.loadItems();
        }
      }

      if (filterType === this.filter.filterVersion.filterType) {
        this.filter.filterVersion.isFilterOpen = false;

        if (this.filter.filterVersion.filterValues.length === 0) {
          this.filter.filterVersion.isSubmitFilter = false;
        } else {
          this.filter.filterVersion.isSubmitFilter = true;
          this.$refs.table.loadItems();
        }
      }

      if (filterType === this.filter.filterTypes.filterType) {
        this.filter.filterTypes.isFilterOpen = false;

        if (this.filter.filterTypes.filterValues.length === 0) {
          this.filter.filterTypes.isSubmitFilter = false;
        } else {
          this.filter.filterTypes.isSubmitFilter = true;
          this.$refs.table.loadItems();
        }
      }

      if (filterType === this.filter.filterStatus.filterType) {
        this.filter.filterStatus.isFilterOpen = false;

        if (this.filter.filterStatus.filterValues.length === 0) {
          this.filter.filterStatus.isSubmitFilter = false;
        } else {
          this.filter.filterStatus.isSubmitFilter = true;
          this.$refs.table.loadItems();
        }
      }
    },

    resetFilter(filterType) {
      if (filterType === this.filter.filterOS.filterType) {
        this.filter.filterOS.isFilterOpen = false;
        this.filter.filterOS.filterValues = [];

        if (this.filter.filterOS.isSubmitFilter) {
          this.filter.filterOS.isSubmitFilter = false;
          this.$refs.table.loadItems();
        }
      }

      if (filterType === this.filter.filterVersion.filterType) {
        this.filter.filterVersion.isFilterOpen = false;
        this.filter.filterVersion.filterValues = [];

        if (this.filter.filterVersion.isSubmitFilter) {
          this.filter.filterVersion.isSubmitFilter = false;
          this.$refs.table.loadItems();
        }
      }

      if (filterType === this.filter.filterTypes.filterType) {
        this.filter.filterTypes.isFilterOpen = false;
        this.filter.filterTypes.filterValues = [];

        if (this.filter.filterTypes.isSubmitFilter) {
          this.filter.filterTypes.isSubmitFilter = false;
          this.$refs.table.loadItems();
        }
      }

      if (filterType === this.filter.filterStatus.filterType) {
        this.filter.filterStatus.isFilterOpen = false;
        this.filter.filterStatus.filterValues = [];

        if (this.filter.filterStatus.isSubmitFilter) {
          this.filter.filterStatus.isSubmitFilter = false;
          this.$refs.table.loadItems();
        }
      }
    },

    // Form infor

    formatSize(bytes) {
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes === 0) return "0 Byte";
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return (bytes / Math.pow(1024, i)).toFixed(2) + " " + sizes[i];
    },

    copyText(text) {
      navigator.clipboard.writeText(text);
      this.$store.dispatch("NOTIFY", {
        type: "success",
        text: "Coppied MD5 to clipboard",
        duration: 10000,
      });
    },

    renderTime(time) {
      return Format(time, "HH:mm DD/MM/YYYY");
    },

    // Search filter version

    getVersionFilter(version) {
      const filter = {
        query: version,
        fields: ["version"],
      };

      const sorting = {
        by: "createdAt",
        order: "desc",
      };

      const params = {
        types:
          this.filter.filterTypes.filterValues.length !== 0
            ? this.filter.filterTypes.filterValues.join(",")
            : "",
      };
      UpdateApi.getRepoVueTable(this.$http, filter, sorting, "", params).then(
        (res) => {
          const combinedValues = res.data.items.map(
            (item) => `${item.version}/${item.type}`
          );
          const uniqueValues = [...new Set(combinedValues)];
          this.listVersions = uniqueValues;
        }
      );
    },

    // Get repo table

    repolistFunc(filtering, sorting, paging) {
      const params = {
        os: this.filter.filterOS.isSubmitFilter
          ? this.filter.filterOS.filterValues.join(",")
          : "",
        types:
          this.filter.filterVersion.isSubmitFilter &&
          !this.filter.filterTypes.isSubmitFilter
            ? this.filter.filterVersion.filterValues.split("/")[1]
            : this.filter.filterTypes.isSubmitFilter
            ? this.filter.filterTypes.filterValues.join(",")
            : this.$route.query.type
            ? this.$route.query.type
            : "",

        versions: this.filter.filterVersion.isSubmitFilter
          ? this.filter.filterVersion.filterValues.split("/")[0]
          : this.$route.query.version
          ? this.$route.query.version
          : "",

        status: this.filter.filterStatus.isSubmitFilter
          ? this.filter.filterStatus.filterValues.join(",")
          : "",
      };
      return UpdateApi.getRepoVueTable(
        this.$http,
        filtering,
        sorting,
        paging,
        params
      ).then(function (res) {
        const dataLength = res.data.items.length;
        for (let i = 0; i < dataLength; i++) {
          res.data.items[i].serial = (paging.page - 1) * paging.perPage + i + 1;
        }
        return res.data;
      });
    },

    // Fetch OS

    fetchOS() {
      UpdateApi.getOSList(this.$http).then((data) => {
        let osData = data;
        this.listOS = osData.map((os) => {
          return { name: os.name, id: os._id };
        });
      });
    },

    // Render table column

    renderOSName(val) {
      const x = this.listOS.find((os) => os.id === val);
      if (!x) {
        return "-";
      }

      return x.name;
    },

    renderOSID(val) {
      const x = this.listOS.find((os) => os.name === val);
      if (!x) {
        return;
      }

      return x.id;
    },

    renderTypeName(val) {
      const x = this.listTypes.find((type) => type.value === val);
      if (!x) {
        return;
      }

      return x.name;
    },

    renderTypeID(val) {
      const x = this.listTypes.find((type) => type.name === val);
      if (!x) {
        return;
      }

      return x.value;
    },

    // Show form

    showForm(type, item) {
      if (type === this.formModal.formInfor.type) {
        this.formModal.formInfor.isFormOpen = true;
        this.formModal.formInfor.repoInfor = item;
      }

      if (type === this.formModal.formMD5.type) {
        this.formModal.formMD5.isFormOpen = true;
        this.formModal.formMD5.repoInfor = item;
      }

      if (type === this.formModal.formConfirmDeleteRepo.type) {
        this.formModal.formConfirmDeleteRepo.isFormOpen = true;
        this.formModal.formConfirmDeleteRepo.repoInfor = item;
      }
    },

    // Delete Repo

    deleteRepo(item) {
      UpdateApi.deleteRepo(this.$http, item._id).then((res) => {
        this.$store.dispatch("NOTIFY", {
          type: "success",
          text: res.message,
          duration: 10000,
        });
        this.formModal.formConfirmDeleteRepo.isFormOpen = false;
        this.$refs.table.loadItems();
      });
    },

    // Download repo

    downloadFile(item) {
      const currentURL =
        window.location.protocol + "//" + window.location.host;

      UpdateApi.downloadRepoFile(this.$http, item._id).then((res) => {
        const downloadTab = window.open(currentURL + res.url, "_blank");
        downloadTab.addEventListener("load", () => {
          downloadTab.close();
        });
      });
    },

    // Check is root

    async checkIsRoot() {
      await UpdateApi.checkIsRoot(this.$http).then((res) => {
        if (res.data && res.data.product === "root") {
          this.isRoot = true;
        }
      });
    },
  },
  mounted() {
    this.checkIsRoot();
    this.fetchOS();
  },
};
</script>

<style lang="scss" scoped>
.nowrap {
  white-space: nowrap;
}

.actions-column-repo {
  display: flex;
  justify-content: center;

  .menu-button:hover {
    opacity: 0.5;
    cursor: pointer;
  }
}

.icon-copy {
  margin-left: 10px;
  cursor: pointer;
  &:hover {
    opacity: 0.5;
  }
}

/deep/ .version-filter {
  .ivu-select-dropdown {
    min-width: 300px;
  }

  .hello {
    width: 95%;
    margin: 0 auto;
  }
}

.menu-list {
  max-height: 200px;
  overflow: scroll;
}

.menu-list.version {
  overflow: inherit;
}

.close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
}

/deep/ button.modal-close {
  display: none;
}
</style>

<style src="vue-select/dist/vue-select.css"></style>
